import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import Navbar from "./Navbar"
import { SolidarityChallengeService } from "../services/Services";
import DOMPurify from 'dompurify'
import Homepage2 from "./Homepage2";
import Countdown from 'react-countdown';
import RequiredAuth, { setSessionStorageInfo } from "../RequiredAuth";
import { oktaAuth } from "../authConfig";
import { useOktaAuth } from "@okta/okta-react";
import { useNavigate, useParams } from "react-router-dom";
const Login = (props) => {

    const [user, setUser] = useState('')
    const [loading, setLoading] = useState(true)
    const [privacyPolicy, setPrivacyPolicy] = useState(false)
    const [challengeStatus, setChallengeStatus] = useState('')
    const [challenge, setChallenge] = useState('')
    const [preChallenge, setPreChallenge] = useState(false)
    const [isAccepted, setisAccepted] = useState(false)
    const [isAcceptedError, setisAcceptedError] = useState(false)
    const service = new SolidarityChallengeService()
    // okta
    const { authState } = useOktaAuth();

    const { section, id } = useParams();
    const navigate = useNavigate()
    const [auth, setAuth] = React.useState('null')
    const [userProfileImage, setUserProfileImage] = React.useState('')
    const loggingIn = async () => oktaAuth.signInWithRedirect({ originalUri: "/" });
    const container = document.getElementById("root");
    const root = createRoot(container);

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        // Render a countdown
        return (
            <div className="flex">
                <div className="countdown_columns">
                    <div className="countdown_counter_text">{zeroPad(days, 2)} </div>
                    <div className="countdown_text" >days</div>
                </div>

                <div className="countdown_columns">
                    <div className="countdown_counter_text" > {zeroPad(hours, 2)}</div>
                    <div className="countdown_text" >hours</div>
                </div>

                <div className="countdown_columns">
                    <div className="countdown_counter_text" > {zeroPad(minutes, 2)}</div>
                    <div className="countdown_text" >minutes</div>
                </div>

                <div className="countdown_columns">
                    <div className="countdown_counter_text" > {zeroPad(seconds, 2)} </div>
                    <div className="countdown_text" >seconds</div>
                </div>

            </div>
        )
    };

    const zeroPad = (num, numZeros) => {
        var n = Math.abs(num);
        var zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
        var zeroString = Math.pow(10, zeros).toString().substr(1);
        if (num < 0) {
            zeroString = '-' + zeroString;
        }
        return zeroString + n;
    }

    useEffect(() => {
        if (section && section === 'privacy_policy') {
            setPrivacyPolicy(true)
        }
    }, [section])

    useEffect(() => {
        if (user) {
            //remove 2 lines to enable entered flag
            //if (user && user.modules && user.modules.gsc && user.modules.gsc.entered)
            //    user.modules.gsc.entered = false
            if (user?.modules?.gsc?.challenges[0]) {
                setChallenge(user.modules.gsc.challenges[0])
            }
            let challenge = 'active'
            if (user?.modules?.gsc?.challenges?.length > 0) {
                let sessionEntered = sessionStorage.getItem('is_entered')
                if (user.modules.gsc.challenges[0].from && new Date(user.modules.gsc.challenges[0].from).getTime() > new Date().getTime()) {

                    setPreChallenge(true)
                }
                else if (user.modules.gsc.challenges[0].is_active) {
                    if (user.modules.gsc.entered) {
                        setLoading(false)
                        root.render(<Homepage2 userReload={userReload} scroll={true} user={user} teamID={id} section={section} />, document.getElementById('root'))
                    }
                } else {
                    challenge = 'just_closed'
                    sessionStorage.setItem('is_entered', false)
                    setLoading(false)
                }
            } else if (user.modules && user.modules.gsc && user.modules.gsc.challenges && user.modules.gsc.challenges.length == 0) {
                challenge = 'closed'
                setLoading(false)
            }
            setTimeout(() => {
                setChallengeStatus(challenge)
            }, 100);
        }
    }, [user]);

    useEffect(() => {

        /*
        let path = window.location.href.split('staging/')
        let original_path = path[0] + 'staging/'
        if (window.location.hostname === 'changemakerschallenge.gucci.cn') {
            path = window.location.href.split('.cn/')
            original_path = path[0] + '.cn/'
        } else if (window.location.hostname === 'changemakerschallenge.gucci.com') {
            path = window.location.href.split('.com/')
            original_path = path[0] + '.com/'
        }
*/
        if (section && section === 'privacy_policy') {
            setPrivacyPolicy(true)
            //window.history.pushState('login', 'login', original_path)
        }
        sessionStorage.setItem('privacy_policy', false)

    }, [auth]);

    const logout = () => {
        oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + '/logout/callback' })
    }

    useEffect(() => {

        let clear_url = window.location.href.split('/login')[0]
        if (clear_url)
            window.history.replaceState({ page: "display_page" }, "display_page", clear_url);
        if (localStorage.getItem('okta-token-storage') && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken) {
            if (!user) {
                service.getUserInfo().then((data) => {
                    setUser(data)
                    setAuth('auth')
                    service.getUserImage(data?.email).then((data) => {
                        setUserProfileImage(data)
                        setLoading(false)
                    }).catch((error) => {
                        setLoading(false)
                        console.log(error)
                    })
                }).catch((error) => {
                    if (error?.response?.status == 401) {
                        if (error?.response?.data?.code === "unauthorized") {
                            setAuth('notauth')
                        } else if (error?.response?.data?.code === "invalid_token") {
                            Promise.resolve(logout())
                        }
                        else if (error?.response?.data?.code === "token_expired") {
                            if (!sessionStorage.getItem('ref')) {
                                sessionStorage.setItem('ref', 'true')
                                window.location.reload()
                            }
                        }
                    }
                    setLoading(false)
                })
            }
        } else if (!authState?.isAuthenticated) {
            if (!window.location.href.includes('code') && window.location.pathname && window.location.pathname.split('/').length > 0)
                Promise.resolve(loggingIn())
        }
        getApplangaData()
    }, [])

    const handleLogin = () => {
        if (!isAccepted && challengeStatus !== 'just_closed') {
            setisAcceptedError(true)
        } else
            if (auth) {
                setLoading(true)
                let service = new SolidarityChallengeService()
                service.setEntered(setLoading)
                // sessionStorage.setItem('is_entered', true)
                root.render(<Homepage2 userReload={userReload} user={user} teamID={id} section={section} />, document.getElementById('root'))
            }
    }


    function getTranslationByKey(key) {
        let translation = ''
        let translation_en = ''
        if (sessionStorage.getItem('translation')) {
            translation = JSON.parse(sessionStorage.getItem('translation'))
            translation_en = JSON.parse(sessionStorage.getItem('translation_en'))
            return translation[key] && translation[key].v ? translation[key].v : (translation_en[key] && translation_en[key].v ? translation_en[key].v : key)
        }
    }
    function getChallengeDuration() {
        /*   let from = new Date(challenge.from)
           let to = new Date(challenge.to)
           let s = from.getDate() + (from.getMonth() != to.getMonth() ? ' ' + from.toLocaleString('en-us', { month: 'short' }) : '') + (from.getFullYear() != to.getFullYear() ? from.getFullYear() : '') + ' - ' + to.getDate() + ' ' + to.toLocaleString('en-us', { month: 'short' }) + ' ' + to.getFullYear()
   */
        let s = '27 MAY - 30 JUNE 2024'
        return s
    }

    function handleIsAcceptedCheckbox() {
        setisAcceptedError(false)
        setisAccepted(!isAccepted)
    }

    function userReload() {

        service.getUserInfo().then((data) => {
            setUser(data)
            setAuth('auth')
            service.getUserImage(data?.email).then((data) => {
                setUserProfileImage(data)
                setLoading(false)
            }).catch((error) => {
                setLoading(false)
                console.log(error)
            })
        }).catch((error) => {
            if (error?.response?.status == 401) {
                if (error?.response?.data?.code === "unauthorized") {
                    setAuth('notauth')
                } else if (error?.response?.data?.code === "invalid_token") {
                    Promise.resolve(logout())
                }
                else if (error?.response?.data?.code === "token_expired") {
                    if (!sessionStorage.getItem('ref')) {
                        sessionStorage.setItem('ref', 'true')
                        window.location.reload()
                    }
                }
            }
            setLoading(false)
        })
    }


    const getApplangaData = async () => {
        service.getTranslation().then(() => {
            //localStorage.setItem('privacy_policy', false)
            let path = window.location.href.split('staging/')
            let original_path = path[0] + 'staging/'
            if (window.location.hostname == 'changemakerschallenge.gucci.cn') {
                path = window.location.href.split('.cn/')
            } else if (window.location.hostname == 'changemakerschallenge.gucci.com') {
                path = window.location.href.split('.com/')
            }


            if (section && section === 'privacy-policy') {
                sessionStorage.setItem('privacy_policy', true)
                //sessionStorage.setItem('privacy_policy_entered', false)
            }
        })
    }

    const handleClosePrivacyPolicy = () => {
        setPrivacyPolicy(false)
        navigate('/')
    }

    return (
        !loading ?
            <div className="login">
                <Navbar user={user} setPrivacyPolicy={setPrivacyPolicy} userProfileImage={userProfileImage} />
                {user.modules ?
                    !user.modules.gsc ?
                        <div className="login_container">
                            <div className="login_info_container">
                                <div className="not_auth_container">
                                    <div className="not_auth_message">{getTranslationByKey('CMC.NOTAUTHORIZED')}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        user.modules.gsc.entered ?
                            (challengeStatus === 'active' ?
                                null
                                :
                                <React.Fragment>
                                    <div className="login_container">
                                        <div className="left_image">
                                        </div>
                                        <div className="right_content">
                                            <div className="login_info_container">
                                                <div>
                                                    {/**/}
                                                    <div className="logos_container">
                                                        <div className="flex" Style="justify-content: center; align-items: center;">
                                                            <div className="about_title_logo">Gucci changemakers</div>
                                                            {/*<div className="logo_separator">x</div>*/}
                                                            <div className="unhcr_logo_container"></div>
                                                        </div>
                                                    </div>
                                                    <div className="main_title_container">
                                                        <div className="login_main_title">{/*getTranslationByKey('CMC.MAINTITLE')*/}
                                                        </div>
                                                    </div>

                                                    {challengeStatus === 'active' ? <div className="login_ppolicy pointer" onClick={() => setPrivacyPolicy(true)}>{getTranslationByKey('CMC.PRIVACYPOLICY')}</div>
                                                        : ''}
                                                    <div className="title_container">
                                                        <div className="login_main_text" dangerouslySetInnerHTML={{ __html: challengeStatus === 'active' ? getTranslationByKey('CMC.INTRO.INPROGRESS.TITLE') : (challengeStatus === 'just_closed' ? getTranslationByKey('CMC.INTRO.JUSTFINISH.TITLE') : getTranslationByKey('CMC.INTRO.INACTIVE.TITLE')) }}></div>
                                                        <br />
                                                        <div className="login_text">
                                                            {challengeStatus === 'active' ? getTranslationByKey('CMC.INTRO.INPROGRESS.TEXT1') : (challengeStatus === 'just_closed' ? getTranslationByKey('CMC.INTRO.JUSTFINISH.TEXT1') : '')}
                                                            <br />
                                                            {challengeStatus === 'active' ? getTranslationByKey('CMC.INTRO.INPROGRESS.TEXT2') : (challengeStatus === 'just_closed' ? getTranslationByKey('CMC.INTRO.JUSTFINISH.TEXT2') : '')}
                                                        </div>
                                                        <br />
                                                    </div>
                                                    {challengeStatus === 'closed' ?
                                                        <div Style={"height: 100px;"}></div> :
                                                        <React.Fragment>
                                                            {challengeStatus === 'active' ? <div className="login_ppolicy pointer" onClick={() => setPrivacyPolicy(true)}>{getTranslationByKey('CMC.PRIVACYPOLICY')}</div>
                                                                : ''}
                                                            {challengeStatus !== 'closed' ?
                                                                <div className="login_button_mobile" onClick={handleLogin}>
                                                                    <div className="login_button_text">
                                                                        {challengeStatus === 'active' ? getTranslationByKey('CMC.INTRO.INPROGRESS.BUTTON') : getTranslationByKey('CMC.INTRO.JUSTFINISH.BUTTON')}
                                                                    </div>
                                                                </div> : null
                                                            }
                                                        </React.Fragment>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div >
                                </React.Fragment>)
                            :
                            //posso togliere tutto quello che sta sopra
                            (privacyPolicy ?
                                <div className="background" Style="margin-top: -25px;height: calc(100vh - 50px);">
                                    <div className="ppolicy_global_container">
                                        <div className="ppolicy_container flex" onClick={() => handleClosePrivacyPolicy()}>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-chevron-left back_left_bar" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                            </svg>
                                            <div className="back_button_ppolicy">Back</div>
                                        </div>
                                        <div className="text_center">
                                            <div className="ppolicy_title">{getTranslationByKey('CMC.PRIVACYPOLICY')}</div>
                                            <div className="ppolicy_text gucci_text mt-3"
                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getTranslationByKey('CMC.PRIVACYPOLICY.TEXT')) }}>

                                            </div>
                                        </div>
                                    </div></div>
                                :

                                user && user.modules.gsc && !loading ?
                                    <React.Fragment>
                                        <div className="login_container">
                                            <div className="left_image">
                                            </div>
                                            <div className="right_content">
                                                <div className="login_info_container">
                                                    <div>
                                                        {/**/}
                                                        <div className="logos_container">
                                                            <div className="flex logos_container_mobile" Style="justify-content: center; align-items: center;">
                                                                <div className="about_title_logo">Gucci changemakers</div>
                                                                {/*<div className="logo_separator">x</div>*/}
                                                                <div className="unhcr_logo_container"></div>
                                                            </div>
                                                        </div>
                                                        <div className="main_title_container">
                                                            <div className="login_main_title">{/*getTranslationByKey('CMC.MAINTITLE')*/}
                                                            </div>
                                                        </div>



                                                        <div className="title_container">
                                                            <div className="login_main_text" dangerouslySetInnerHTML={{
                                                                __html: challengeStatus === 'active' ?

                                                                    (challenge ? getTranslationByKey('CMC.CHALLENGEDATE') : '')
                                                                    : (challengeStatus === 'just_closed' ? getTranslationByKey('CMC.INTRO.JUSTFINISH.TITLE') : getTranslationByKey('CMC.INTRO.INACTIVE.TITLE'))
                                                            }}></div>
                                                            <br />
                                                            {challengeStatus === 'active' ? <div Style={'text-transform:uppercase;margin-bottom:5px; font-size:18px'} dangerouslySetInnerHTML={{ __html: getTranslationByKey('CMC.INTRO.INPROGRESS.TITLE2') }}></div> : ''}

                                                            <div className="login_text" dangerouslySetInnerHTML={{
                                                                __html:
                                                                    challengeStatus === 'active' ? getTranslationByKey('CMC.INTRO.INPROGRESS.TEXT3') : (challengeStatus === 'just_closed' ? getTranslationByKey('CMC.INTRO.JUSTFINISH.TEXT1') : '')
                                                            }}></div>
                                                            <div className="login_text" Style="text-align: -webkit-center; margin-top: 20px;" dangerouslySetInnerHTML={{
                                                                __html: challengeStatus === 'active' ? (!preChallenge ? getTranslationByKey('CMC.INTRO.INPROGRESS.TEXT4') : '') : (challengeStatus === 'just_closed' ? getTranslationByKey('CMC.INTRO.JUSTFINISH.TEXT2') : '')
                                                            }}>
                                                            </div>
                                                        </div>
                                                        {challengeStatus === 'closed' ?
                                                            <div Style={"height: 100px;"}></div>
                                                            :
                                                            <React.Fragment>
                                                                {!preChallenge ? <div className="w-85">
                                                                    <div className="isAcceptedCheckbox_container">
                                                                        <input checked={isAccepted} type="checkbox" id="isAcceptedCheckbox" name="isAcceptedCheckbox" onChange={() => handleIsAcceptedCheckbox()} />
                                                                        <label id="isAcceptedCheckbox_label" Style={"padding-left: 10px;"} >
                                                                            <span className="flex">
                                                                                <div className="label_checkbox_link pointer" dangerouslySetInnerHTML={{ __html: getTranslationByKey('CMC.TERMSANDCONDITIONS.TEXT') }}></div>
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div> : ''}
                                                                {isAcceptedError ? <div className="terms_error"> {getTranslationByKey('CMC.TERMSANDCONDITIONS.ERROR')}</div> : <div Style={"min-height: 30px;"}></div>}
                                                                {challengeStatus === 'active' ? <div className="login_ppolicy pointer" Style={!preChallenge ? '' : 'margin-top:-20px'} onClick={() => setPrivacyPolicy(true)}>{getTranslationByKey('CMC.PRIVACYPOLICY')}</div>
                                                                    : ''}
                                                                {!preChallenge ? <div>
                                                                    <div className="login_button_mobile" onClick={handleLogin}>

                                                                        <div className="login_button_text">
                                                                            {challengeStatus === 'active' ? getTranslationByKey('CMC.INTRO.INPROGRESS.BUTTON') : getTranslationByKey('CMC.INTRO.JUSTFINISH.BUTTON')}
                                                                        </div>
                                                                    </div>
                                                                </div> : ''}
                                                                {!preChallenge && challenge.countdown_date ? '' :
                                                                    <div className="w-50">

                                                                        <div className='cd' Style={'margin-top:20px; font-family:"GucciSans-Book"'}>
                                                                            <Countdown
                                                                                date={new Date(challenge?.countdown_date)}
                                                                                renderer={renderer}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                    :
                                    (!loading ?
                                        <div className="not_auth_container">
                                            <div className="not_auth_message">{getTranslationByKey('CMC.NOTAUTHORIZED')}
                                            </div>
                                        </div>
                                        :
                                        <div className="not_auth_container">
                                            <div className="not_auth_message">
                                                <div className="loader-cont"><div className="loader"> </div></div>
                                            </div>
                                        </div>)

                            )

                    :
                    <div className="login_container">
                        <div className="login_info_container">
                            <div className="not_auth_container">
                                <div className="not_auth_message">{getTranslationByKey('CMC.NOTAUTHORIZED')}
                                </div>
                            </div>
                        </div>
                    </div>

                }
            </div >
            : <div className="not_auth_container">
                <div className="not_auth_message">
                    <div className="loader-cont"><div className="loader"></div></div>
                </div>
            </div>
    )

}

export default Login;